export default "__VITE_ASSET__DDYqdpDA__"